import { useProductTranslations } from "../../hooks/TranslationHooks";
import { productStockStatus } from "../../utils/ProductUtils";

import stockIconOK from "../../assets/icons/stock_ok.svg";
import stockIconWarn from "../../assets/icons/stock_warn.svg";
import stockIconTime from "../../assets/icons/stock_time.svg";
import stockIconEmpty from "../../assets/icons/stock_empty.svg";
import stockIconUnknown from "../../assets/icons/stock_unknown.svg";

const ProductStock = ({ className, product, cartItem, b2b = false }) => {
  const tp = useProductTranslations();
  const stockStatus = productStockStatus(product, cartItem, tp, b2b);

  return (
    <div className={className} style={{ display: "flex" }}>
      <p style={{ marginRight: "0.7em" }}>
        {stockStatus.icon === "ok" ? (
          <img
            data-icon={stockStatus.icon}
            src={stockIconOK}
            className="icon"
            alt="✓"
          />
        ) : stockStatus.icon === "warn" ? (
          <img
            data-icon={stockStatus.icon}
            src={stockIconWarn}
            className="icon"
            alt="⚠"
          />
        ) : stockStatus.icon === "time" ? (
          <img
            data-icon={stockStatus.icon}
            src={stockIconTime}
            className="icon"
            alt="⧖"
          />
        ) : stockStatus.icon === "empty" ? (
          <img
            data-icon={stockStatus.icon}
            src={stockIconEmpty}
            className="icon"
            alt="x"
          />
        ) : (
          <img
            data-icon={"unknown"}
            src={stockIconUnknown}
            className="icon"
            alt="?"
          />
        )}
      </p>
      <p>
        {stockStatus.amount} {stockStatus.message}
      </p>
    </div>
  );
};

export default ProductStock;
